module.exports = "/images/pin1.svg?bc5a9aa8ca7d674041217988a5d76dd8";